import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  gql,
  useMutation,
} from "@apollo/client";
import { CheckboxProfile } from "../../components/inputs/CheckboxProfile";
import { TextInputWTitleDisable } from "../inputs/TextInputWTitleDisable";
import { InputTitle } from "../inputs/InputTitle";
import { TextInputWTitle } from "../inputs/TextInputWTitle";
import { SelectDateInput } from "../inputs/SelectDateInput";
import { TextBtn } from "../inputs/TextBtn";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";


const StyleCss = styled.div`
  grid-column: 1 / 13;
  width: auto !important;
  .loading-ep {
    display: flex;
    justify-content: center;
    margin: 100px auto 0;
  }
  .container {
    justify-content: space-between;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 40px 40px 40px 20px;
    .rightelement,
    .leftelement {
      width: 48%;
    }
    .full-width {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(12, calc(calc(100% / 12) - calc(110px / 12)));
      grid-gap: 10px;
      margin: 2rem 0 0;
      padding: 2rem 0 0;
      border-top: 1px solid var(--n-grey-3);
    }
    .vertical-devider {
      width: 1px;
      border-left: 1px solid var(--n-grey-3);
    }
    .row {
      margin: 2rem 0;
      padding: 0 10px;
      :first-child{
        margin: 0 0 2rem;
      }
      .textarea {
        height: 5rem !important;
        width: 50% !important;
      }
      .new-input {
        padding: 0;
      }
      .image-file {
        display: flex;
        width: calc(100% - 1rem);
        padding: 0.5rem;
        border-radius: var(--border-radius);
        border: 1px solid var(--n-grey-3);
        background-color: var(--n-grey-1);
        outline: none;
        transition: var(--trans-1);
        font-size: var(--fs-textfield);
        .texts {
          width: calc(60% - 1.5rem);
          margin: 0 0.5rem 0 1rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            margin: 6px 0;
            font-size: 11px;
            font-weight: 500;
          }
          .desc {
            font-size: 11px;
            font-weight: normal;
            text-align: justify;
            color: var(--n-grey-7);
          }
        }
        .image {
          width: 40%;
          padding-top: 40%;
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          img {
            width: 100%;
            position: absolute;
            inset: 0 0 0 0;
            display: block;
            background-color: var(--n-grey-3);
          }
        }
      }
    }
  }
`;

// _id: ID
// Email: String
// FName: String
// LName: String
// Code: String

const AddPodcasterData_Mutation = gql`
  mutation AddPodcasterData(
    $_id: ID
    $Email: String!
    $FName: String!
    $LName: String!
    $Code: String!
  ) {
    updateUserData(
      input: {
        _id: $_id
        Email: $Email
        FName: $FName
        LName: $LName
        Code: $Code
      }
    ) {
      _id
      Email
      FName
      LName
      Code
    }
  }
`;


function PersonalData(props) {
  const params = useLocation();
  const returnPath = (new URLSearchParams(params.search)).get("return")
  const history = useHistory()

  const [id, setID] = useState("");
  const [mobile, setMobile] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [gender, setGender] = useState("");
  const [birthday, setBirthday] = useState("");
  const [changed, setChanged] = useState(false);

  const [errors, setErrors] = useState({
    name: "",
    surname: "",
    username: "",
    email: "",
    code: "",
    gender: "",
    birthday: "",
  });

  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("user-lotus"));
    // set initial if exists
    if (data) {
      setID(data._id);
      setMobile(data.Mobile);
      setName(data.FName);
      setSurname(data.LName);
      setCode(data.Code);
      setEmail(data.Email);
      setChanged(false);
    }
  }, []);

  const [CDataQuery, { loading }] = useMutation(
    AddPodcasterData_Mutation,
    {
      onCompleted: proccessData,
    }
  );

  function proccessData(newData) {
    console.log(newData);
    if (newData.updateUserData._id) {
      // logined send to other parts
      props.updateError({
          text: 'Saved successfully',
          time: 3,
          type: 'confirm'
      });
      props.updateLogin();
      cancel();
    } else {
      let newData2 = newData.updateUserData;
      let newError = errors;
      if (newData2.Name) {
        newError.name = newData2.Name;
      }
      if (newData2.Surname) {
        newError.surname = newData2.Surname;
      }
      if (newData2.ShowName) {
        newError.username = newData2.ShowName;
      }
      if (newData2.Email) {
        newError.email = newData2.Email;
      }
      if (newData2.Code) {
        newError.code = newData2.Code;
      }
      setErrors(newError);
    }
  }


  onchange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
      case "Name":
        setName(value);
        break;
      case "Surname":
        setSurname(value);
        break;
      case "Username":
        setUsername(value);
        break;
      case "gender":
        setGender(value);
        break;
      case "Code":
        setCode(value);
        break;
      case "birthday":
        setBirthday(value);
        break;
      case "Email":
        setEmail(value);
        break;
      default:
        break;
    }
    setChanged(true);
  };

  function sendData() {
    // console.log('here')
    setChanged(false);
    CDataQuery({
      variables: {
        _id: id,
        Email: email,
        FName: name,
        LName: surname,
        Code: code,
      },
    });
  }


  const checkData = () => {
    if (
      name &&
      surname &&
      code &&
      email &&
      // gender &&
      // birthday &&
      changed
    ) {
      return true;
    } else {
      return false;
    }
  };
  const cancel = () => {
    if(returnPath){
      history.push(returnPath);
      return; 
    }
    history.push("/work/personal-data");
  };

  let data2 = props.userdata
  return (
    <StyleCss>
      <div className="container">
        <div className="rightelement">
          <div className="row">
            <TextInputWTitle
              name={"Email"}
              value={email}
              error={errors.name}
              onchange={onchange}
              title={'Email'}
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Name"}
              value={name}
              error={errors.name}
              onchange={onchange}
              title="First Name"
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Surname"}
              value={surname}
              error={errors.surname}
              onchange={onchange}
              title="Last Name"
            />
          </div>
          <div className="row">
            <TextInputWTitle
              name={"Code"}
              value={code}
              error={errors.code}
              onchange={onchange}
              title="National Code"
            />
          </div>
          {/* <div className="row">
            <div className="new-input">
              <InputTitle>Gender</InputTitle>
              <CheckboxProfile value={gender} name={'gender'} onchange={onchange}/>
            </div>
          </div>
          <div className="row">
            <div className="new-input">
              <InputTitle>Birthdate</InputTitle>
              <SelectDateInput value={birthday} name={'birthday'} onchange={onchange} error={''}/>
            </div>
          </div> */}
        </div>
        <div className='vertical-devider'></div>
        <div className="leftelement">
          <div className="row">
            <TextInputWTitleDisable
              value={data2.Mobile}
              title={'Mobile'}
              help={'For changing mobile number contact support'}
            />
          </div>
        </div>
        <div className='full-width'>
          <div style={{ gridColumn: "7 / 9" }}>
            <TextBtn
              onclick={cancel}
              text={"Cancel"}
              type={""}
              newType1={true}
            />
          </div>
          <div style={{ gridColumn: "9 / 13" }}>
            <TextBtn
                text={"Save changes"}
                type={"submit"}
                onclick={sendData}
                loading={loading}
                disabled={!checkData() || loading}
            />
          </div>
        </div>
      </div>
    </StyleCss>
  );

  // if (window.innerWidth > 700) {
  //   return (
  //       <StyleCss className="main-box">
  //           <Prompt when={changed} message={'تغییرات ذخیره نشده دارید. آیا مایل به حذف آنها هستید؟'}/>
  //               <div className="title-bar">
  //                   <div className="title">
  //                   <div className="icon"><UserProfile/></div>
  //                   <div className="text">اطلاعات شخصی</div>
  //                   </div>
  //                   <div className="action"><Edit/></div>
  //               </div>
  //               <div className="content">
  //               <div className="main-content">
  //                   {/* main content goes here */}
                    
  //                   <div className="heightspacertitle" />
  //                   <div className="grid-devider commentsstyles" />
  //                   <div className="container">
  //                   {/* <div className="podcaster">
  //                       <img src={ProfilePic} alt="profile" />
  //                       <div className="title">
  //                       درباره من
  //                       <textarea rows="9" />
  //                       <div style={{ paddingTop: "2rem" }} className="title">
  //                           آدرس شبکه های اجتماعی
  //                       </div>
  //                       <TextInput error={""} placeHolder="" ltr={true} />
  //                       </div>
  //                   </div> */}
  //                   <div className="inputs">
  //                       <form>
  //                       <div className="title"> نام</div>
  //                       <TextInput
  //                           name={"Name"}
  //                           value={name}
  //                           error={errors.name}
  //                           placeHolder={"علی"}
  //                           onchange={onchange}
  //                       />
  //                       <div className="title">نام خانوادگی</div>
  //                       <TextInput
  //                           name={"Surname"}
  //                           value={surname}
  //                           error={errors.surname}
  //                           placeHolder={"علیزاده"}
  //                           onchange={onchange}
  //                       />
  //                       <div className="title">
  //                           نام نمایشی
  //                           <Tooltip style={{ margin: "0" }}>
  //                           {" "}
  //                           نامی که در صفحه پادکست شما به عنوان تولید کننده نمایش داده
  //                           میشود
  //                           </Tooltip>
  //                       </div>
  //                       <TextInput
  //                           name={"Username"}
  //                           value={username}
  //                           error={errors.username}
  //                           placeHolder={"علی پادکستر"}
  //                           onchange={onchange}
  //                       />
  //                       <div>
  //                           <div className="title"> جنسیت</div>
  //                           <div className="checkbox">
  //                           <CheckboxProfile value={gender} name={'gender'} onchange={onchange}/>
  //                           </div>
  //                       </div>
  //                       <div className="title"> تاریخ تولد</div>
  //                       <SelectDateInput value={birthday} name={'birthday'} onchange={onchange} error={''}/>

  //                       <div className="title"> ایمیل</div>
  //                       <TextInput
  //                           name={"Email"}
  //                           value={email}
  //                           error={errors.email}
  //                           placeHolder={"example@example.com"}
  //                           onchange={onchange}
  //                           ltr={true}
  //                       />
  //                       <TextBtn
  //                           className={"btn"}
  //                           style={{ width: "45%", margin: " 0 auto 0px 0px" }}
  //                           text={"ثبت"}
  //                           type={"submit"}
  //                           onclick={sendData}
  //                           loading={loading}
  //                           disabled={!checkData() || loading}
  //                       />
  //                       </form>
  //                   </div>
  //                   </div>
  //               </div>
  //               </div>
  //       </StyleCss>
  //   );
  // } else {
  //   return (
  //       <StyleCss>
  //       <Prompt when={changed} message={'تغییرات ذخیره نشده دارید. آیا مایل به حذف آنها هستید؟'}/>
  //         <div className="titles">
  //           <div className="main-title">
  //             <div className="text">
  //               حساب کاربری
  //               {/* {newData.Pr_Name ? newData.Pr_Name : newData.title} */}
  //             </div>
  //           </div>
  //         </div>

  //         <div className="main-content">
  //           {/* main content goes here */}

  //           <div className="base-grid">
  //             {" "}
  //             <div className="right-title">درباره پادکستر</div>
  //           </div>
  //           <div className="spacer-s" />
  //           <div className="grid-devider commentsstyles" />
  //           <div className="container">
  //             <div className="podcaster">
  //               <img src={ProfilePic} alt="profile" />
  //             </div>
  //             <div className="inputs">
  //               <form>
  //                 <div className="title"> نام</div>
  //                 <TextInput error={""} placeHolder="سروش" ltr={false} />
  //                 <div className="title">نام خانوادگی</div>
  //                 <TextInput error={""} placeHolder="ایرانی" ltr={false} />
  //                 <div className="title">
  //                   نام نمایشی
  //                   <Tooltip style={{ margin: "0" }}>
  //                     {" "}
  //                     نامی که در صفحه پادکست شما به عنوان تولید کننده نمایش داده
  //                     میشود
  //                   </Tooltip>
  //                 </div>
  //                 <TextInput error={""} placeHolder="" ltr={false} />
  //                 <div>
  //                   {" "}
  //                   <div className="  titlecheckbox "> جنسیت</div>
  //                   <div className="checkbox">
  //                     <CheckboxProfile />
  //                   </div>
  //                 </div>
  //                 <div className="title"> تاریخ تولد</div>
  //                 <TextInput
  //                   error={""}
  //                   placeHolder="
  //                  اردیبهشت
  //                   1371
  //                   "
  //                   ltr={false}
  //                 />
  //                 <div className="title"> ایمیل</div>
  //                 <TextInput
  //                   classes={"textpass"}
  //                   style={{ textAlign: "left" }}
  //                   error={""}
  //                   placeHolder="yourmail@gmail.com"
  //                   ltr={true}
  //                 />
  //                 <div style={{ marginTop: "0.5rem" }} className="title">
  //                   آدرس شبکه های اجتماعی
  //                 </div>
  //                 <TextInput
  //                   style={{ marginBottom: "0.5rem" }}
  //                   error={""}
  //                   placeHolder=""
  //                   ltr={true}
  //                 />
  //                 درباره من
  //                 <textarea rows="9" />
  //                 <TextBtn
  //                   className={"btn"}
  //                   style={{ margin: " 2rem auto 0 0" }}
  //                   text={"ثبت"}
  //                   type={"submit"}
  //                   // onclick={sendData}
  //                   // loading={updatePodcastDataState.loading}
  //                   // disabled={!checkData() || updatePodcastDataState.loading}
  //                 />
  //               </form>
  //             </div>
  //           </div>
  //         </div>
  //       </StyleCss>
  //   );
  // }
}
export default PersonalData;
